import _ from 'lodash';
import BasicSelect from './Basic';
import FIELD_TYPES from '../../../../../../configs/fieldTypes';

import * as AXIS_TYPES from '../../../../../../configs/grid/axisTypes';
import { getDateItems } from '../../../../../../utils/getDateItems';

class SelectAxis extends BasicSelect {
  getAvailableValues(fields) {
    return _.compact(
      _.flatten(
        fields.toArray().map((field) => {
          const fieldId = field.get('id');
          const fieldName = field.get('name');

          switch (field.get('type')) {
            case FIELD_TYPES.DATE:
              return getDateItems(field.getIn(['config', 'type'])).map(({ title, subType }) => ({
                type: AXIS_TYPES.FIELD,
                subType,
                title: `${fieldName} ${title}`,
                fieldId,
              }));
            case FIELD_TYPES.DROPDOWN:
            case FIELD_TYPES.CHECKBOXES:
            case FIELD_TYPES.RADIOBUTTON:
            case FIELD_TYPES.STARS:
            case FIELD_TYPES.USER:
            case FIELD_TYPES.OBJECT:
            case FIELD_TYPES.SWITCH:
              return {
                type: AXIS_TYPES.FIELD,
                fieldId,
                title: fieldName,
              };
          }
        }),
      ),
    );
  }
}

export default SelectAxis;
